import { handleActions } from 'redux-actions';
/** Wraps actionHandlers in order to allow using a function that returns
 *  a reducer's initial state instead of using a plain object */ function actionHandlersWithInitialStateFunction(handlers, initialStateFunction) {
    const actionHandlers = handleActions(handlers, {});
    return (state = initialStateFunction(), action)=>actionHandlers(state, action);
}
export default actionHandlersWithInitialStateFunction;

//# sourceMappingURL=actionHandlersWithInitialStateFunction.js.map